import { gql } from 'graphql-tag';

export const createPendingFreeTrialRedemption = gql`
  mutation erCreatePendingFreeTrialRedemption {
    erCreatePendingFreeTrialRedemption {
      code
      success
      message
    }
  }
`;
